module.exports = __webpack_public_path__ + "img/9_63.aa5841be.png";